var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.104 9.27091H10.729V4.89591C10.729 4.70253 10.6522 4.51706 10.5154 4.38032C10.3787 4.24357 10.1932 4.16675 9.99984 4.16675C9.80645 4.16675 9.62098 4.24357 9.48424 4.38032C9.34749 4.51706 9.27067 4.70253 9.27067 4.89591V9.27091H4.89567C4.70228 9.27091 4.51682 9.34774 4.38007 9.48448C4.24333 9.62123 4.1665 9.80669 4.1665 10.0001C4.1665 10.1935 4.24333 10.3789 4.38007 10.5157C4.51682 10.6524 4.70228 10.7292 4.89567 10.7292H9.27067V15.1042C9.27067 15.2976 9.34749 15.4831 9.48424 15.6198C9.62098 15.7566 9.80645 15.8334 9.99984 15.8334C10.1932 15.8334 10.3787 15.7566 10.5154 15.6198C10.6522 15.4831 10.729 15.2976 10.729 15.1042V10.7292H15.104C15.2974 10.7292 15.4829 10.6524 15.6196 10.5157C15.7563 10.3789 15.8332 10.1935 15.8332 10.0001C15.8332 9.80669 15.7563 9.62123 15.6196 9.48448C15.4829 9.34774 15.2974 9.27091 15.104 9.27091Z",
    fill: "#1F85CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.698d7c6416114fec733f105988bbc763.svg";
export { ForwardRef as ReactComponent };